export default "__VITE_ASSET__F0N9Sz6b__"